import { rest } from 'msw';
import { dynamicEnvs } from './fixtures/qa-env.fixture';
import { getEnv } from 'util/getEnv';

export const qaEnvsMock = fn =>
  rest.get(
    `${getEnv('REACT_APP_QA_URL')}/incentivio-admin-api/dynamicEnvs`,
    fn,
  );

export const handlers = () => [
  qaEnvsMock((_req, res, ctx) => {
    return res(ctx.json(dynamicEnvs));
  }),
];
